"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNPAID_TIME_ACTION_ROW_TEST_ID = exports.UNPAID_TIME_CHEVRON_RIGHT_ICON_TEST_ID = exports.PAY_PERIOD_HOURLY_BREAKDOWN_VIEW_TEST_ID = void 0;
exports.PAY_PERIOD_HOURLY_BREAKDOWN_VIEW_TEST_ID = 'pay-period-hourly-breakdown-view';
exports.UNPAID_TIME_CHEVRON_RIGHT_ICON_TEST_ID = 'unpaid-time-chevron-right-icon';
exports.UNPAID_TIME_ACTION_ROW_TEST_ID = 'unpaid-time-action-row';
